import { PAYMENTS_API_URL } from 'data/constants';

export const storeDepositLoadTimes = (depositId: string, resource: string) => {
  const entries = performance.getEntriesByType('resource');
  const loadTimes = entries
    .filter(
      (entry): entry is PerformanceResourceTiming =>
        entry.entryType === 'resource',
    )
    .filter(
      (entry) =>
        entry.initiatorType === 'fetch' && entry.name.includes(resource),
    )
    .map((entry) => entry.duration);

  try {
    void fetch(`${PAYMENTS_API_URL}/public/payments/${depositId}/load_times`, {
      method: 'POST',
      body: JSON.stringify({ loadTimes, resource }),
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch {
    console.log('Error saving load times');
  }
};
